import React from "react";
import {
    BrowserRouter as Router,
    Routes,
    Route,
} from "react-router-dom";

import Page1 from "./components/Page1";
import Page2 from "./components/Page2";
import Page3 from "./components/Page3";
import Page4 from "./components/Page4";
import Page5 from "./components/Page5";
import PendingList from "./components/PendingList";
import Admin from "./components/Admin";
import SliFull from "./components/SliFull";
import Login from "./components/Login";
import ProtectedRoute from "./components/ProtectedRoute";
import Header from "./components/Header";
import Footer from "./components/Footer";
import { FormDataProvider } from "./components/FormDataContext";

import UnlockPage from "./components/UnlockPage";
import SiteLockGuard from "./components/SiteLockGuard";

import "./App.css";

const App = () => {
    return (
        <FormDataProvider>
            <Router>
                <Header />

                {/* Կայքի ժամանակավոր կողպում (մինչ պաշտոնական մեկնարկը) */}
                <SiteLockGuard>
                    <Routes>
                        <Route path="/unlock" element={<UnlockPage />} />

                        <Route path="/" element={<Page1 />} />
                        <Route path="/page2" element={<Page2 />} />
                        <Route path="/page3" element={<Page3 />} />
                        <Route path="/page4" element={<Page4 />} />
                        <Route path="/page5" element={<Page5 />} />

                        <Route path="/login/manager" element={<Login role="manager" />} />
                        <Route path="/login/admin" element={<Login role="admin" />} />

                        <Route
                            path="/manager"
                            element={
                                <ProtectedRoute role="manager">
                                    <PendingList />
                                </ProtectedRoute>
                            }
                        />

                        <Route
                            path="/admin"
                            element={
                                <ProtectedRoute role="admin">
                                    <Admin />
                                </ProtectedRoute>
                            }
                        />

                        <Route path="/sli" element={<SliFull />} />
                    </Routes>
                </SiteLockGuard>

                <Footer />
            </Router>
        </FormDataProvider>
    );
};

export default App;
